import angular from 'angular';
import LspImageComponent from './lsp-image-component';

export default angular.module('lsp-image', []).component('lspImg', new LspImageComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-image/lsp-image-module.js